export default {
  API_BASE_URL: 'http://192.168.18.148:8080/api'
};



// WEBPACK FOOTER //
// ./src/config/config.dev.js